export default "__VITE_ASSET__BYubzhWZ__"